module.exports = __webpack_public_path__ + "img/primary-down-arrow.2f1bfe3b.svg";